import { StatusCadastroEnum } from "../enum";
import { Funcionario } from "../funcionario";

export class CRMTipoAtividade {
    id: number;
    descricao: string;
    icone: string;
    vincularOrcamento: boolean;
    responsaveis: Funcionario[];
    statusCadastro: StatusCadastroEnum = StatusCadastroEnum.Ativo;
    habilitaGanho: boolean;
    habilitaPerda: boolean;
    textoGanho: string;
    textoPerda: string;
}